import { render, staticRenderFns } from "./HeaderTime.vue?vue&type=template&id=48a346b3&scoped=true&lang=pug"
import script from "./HeaderTime.vue?vue&type=script&lang=js"
export * from "./HeaderTime.vue?vue&type=script&lang=js"
import style0 from "./HeaderTime.vue?vue&type=style&index=0&id=48a346b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a346b3",
  null
  
)

export default component.exports